import { useMutation } from '@apollo/client/react';
import { MetadataUpdateCategoryDocument } from './mutation.gql';
export function useUpdateCategory(documentId) {
    const [mutation, state] = useMutation(MetadataUpdateCategoryDocument);
    const handleMutation = (categoryId) => mutation({
        variables: {
            documentId,
            categoryId,
            bundleVersion: process.env.PLEDITOR_BUNDLE_VERSION,
        },
    });
    return Object.assign({ mutation: handleMutation }, state);
}
